import React from "react";
import { useTranslation } from "react-i18next";
import SharedLogin, { SharedLoginProps } from "../../SharedLogin/SharedLogin";

export interface SignInDialogProps {
  onSuccess: SharedLoginProps["onSuccess"];
}

// Required sign-in view — centered dialog over a dimmed backdrop.
// Reuses the standalone SharedLogin component and OTP/provision logic.
// The close control is intentionally omitted until the user is signed in.
const SignInDialog: React.FC<SignInDialogProps> = ({ onSuccess }) => {
  const { t } = useTranslation("hailing");
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-[rgba(15,21,26,0.45)] p-6">
      <div
        role="dialog"
        aria-modal="true"
        aria-label={t("steps.signin.modalTitle")}
        className="w-full max-w-[440px] max-h-[90dvh] overflow-y-auto rounded-3xl bg-white p-8 shadow-[0_24px_64px_rgba(15,21,26,0.3)]"
      >
        <SharedLogin
          bare
          showLanguageToggle={false}
          onSuccess={onSuccess}
          phoneTitle={t("steps.signin.modalTitle")}
          phoneDescription={t("steps.signin.modalDescription")}
          phoneFieldLabel={t("steps.signin.modalFieldLabel")}
          showMarketingConsent={false}
          phoneFooterText={t("steps.signin.modalFooter")}
          // New riders give their name (and optional email) after the code.
          showCreateAccount
          createAccountText={{
            description: t("steps.signin.createAccountDescription"),
            submitLabel: t("steps.signin.createAccountSubmit"),
          }}
        />
      </div>
    </div>
  );
};

export default SignInDialog;
